// Shared staff/fixture exclusions for both products and CRM.
import { isMondaySandbox, type MondayBoardIds } from "./monday-client";

const INTERNAL_EMAIL_DOMAINS = [
  "@greenzero.eu",
  "@oekopunktemarkt.de",
  "@omsw.co",
  "@davidsmith.eu",
  "@landvest.eu",
];

const INTERNAL_EMAILS_EXACT = new Set(["erik.frister@gmail.com"]);

export function isInternalEmail(email: string): boolean {
  const lower = email.toLowerCase();
  if (INTERNAL_EMAIL_DOMAINS.some((d) => lower.includes(d))) return true;
  return INTERNAL_EMAILS_EXACT.has(lower);
}

export const SEED_HOSTS: ReadonlySet<string> = new Set([
  "test.local",
  "test.com",
  "example.com",
  "example.org",
  "oekopunktemarkt.test",
]);

export function isSeedHost(host: string | null | undefined): boolean {
  if (!host) return false;
  for (const seed of SEED_HOSTS) if (host === seed || host.endsWith(`.${seed}`)) return true;
  return false;
}

/**
 * Whether a CRM writer must leave this address alone. A seed host is a fixture,
 * never a person. Staff test the funnel in production, so on the live boards
 * their enquiries are test data. On the Sandbox (staging, ARCH-057) staff are
 * the testers, and their lead is the point of the test.
 */
export function isExcludedFromCrm(
  email: string | null | undefined,
  boards?: MondayBoardIds
): boolean {
  const address = email?.trim().toLowerCase();
  if (!address) return false;
  const at = address.lastIndexOf("@");
  if (at >= 0 && isSeedHost(address.slice(at + 1))) return true;
  // The boards are read from the environment only for a staff address.
  return isInternalEmail(address) && !isMondaySandbox(boards);
}
